import { Box } from '@mui/material'
import React from 'react'
import AccountTable from './AccountTable'
import CreateAccount from './CreateAccount'

const Account = (props) => {
  const {
    total_users_count,
    is_loading,
    page,
    is_account_modal_open,
    c_action,
    user_id,
    selected_data,
    handleAccountModal,
    handleAccountSubmit,
    handleAccountUpdate,
    handleActivateDeactivateUsers,
    handleAccountUpdateModal,
    company_process
  } = props
  return (
    <Box>
      <AccountTable
        is_loading={is_loading}
        total_users_count={total_users_count}
        page={page}
        handleActivateDeactivateUsers={handleActivateDeactivateUsers}
        is_account_modal_open={is_account_modal_open}
        handleAccountUpdateModal={handleAccountUpdateModal}
      />
      <CreateAccount
        is_account_modal_open={is_account_modal_open}
        c_action={c_action}
        user_id={user_id}
        selected_data={selected_data}
        handleAccountModal={handleAccountModal}
        handleAccountSubmit={handleAccountSubmit}
        handleAccountUpdate={handleAccountUpdate}
        company_process={company_process}
      />
    </Box>
  )
}

export default Account
